import { Link } from "react-router-dom";

export const Notfound = () => {
  return (
    <div className="container-fluid py-5 mb-5">
      <div className="container text-center text-dark py-5">
        <h1 className="display-1 text-primary">404</h1>
        <h2 className="mb-4">Halaman Tidak Ditemukan</h2>
        <p className="mb-4">
          Maaf, halaman yang Anda cari tidak ada atau sudah dipindahkan.
        </p>
        <Link to="/" className="btn btn-primary px-5 py-3 rounded-pill">
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
};
